import ScrollMagic from 'scrollmagic';
import 'animation.gsap';
import data from './scroll-data';
import { createAnimation } from './scroll-animations';

export default () => {
  const controller = new ScrollMagic.Controller();

  data.forEach((item) => {
    if (!Object.values(item).length) {
      return;
    }

    createAnimation(item, controller);
  });
};



// WEBPACK FOOTER //
// ./wordpress/wp-content/themes/foach/js/modules/scroll-creator.js